import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBilka = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 128 128",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M52.89 128H4V0h49.266c45.016 0 70.092 5.397 70.092 35.026v1.533c0 11.105-4.427 20.678-15.492 26.009C120.016 67.743 124 78.582 124 88.065v1.71C124 123.092 95.715 128 52.779 128m28.683-91.086c0-10.683-7.525-12.482-23.681-12.482-4.183 0-7.414 0-11.774.155V51.73H61.21c16.71 0 20.317-4.443 20.317-13.615zm.376 50.618c-.177-9.284-4.559-13.593-20.317-13.593h-15.47v29.274c4.183.178 7.215.178 11.774.178 16.909 0 24.124-2.422 24.124-13.949z"
	})
});
export default SvgIconBilka;
